import { type Env, ENVS, type Platform, PLATFORMS } from './envConsts';

interface UrlParts {
  region: string;
  env: Env;
  platform: Platform;
}

const DEFAULT_ENV = ENVS.QA;
const DEFAULT_REGION = 'US';
const EMEA_REGION = 'EMEA';
const EMEA_EXTENSION = 'eu';

export function parseURL(url: string): UrlParts {
  const pattern =
    /^(?:https?:\/\/)?(?:(?<subdomain>[a-zA-Z0-9-]+)\.)?(?<platform>acc|cpa)(?:[-.](?<env>staging|qa|stg))?(?:\.(?<region>[^.]+))?\.autodesk\.(?<extension>com|eu)$/;

  // Match the URL against the pattern
  const match = url.match(pattern);

  const { env, region, extension, platform } = match?.groups || {
    env: DEFAULT_ENV,
    region: DEFAULT_REGION,
    platform: PLATFORMS.ACC,
  };

  const isEMEA = extension === EMEA_EXTENSION;
  const envToUse = (
    env === 'stg' ? ENVS.STAGING : env?.toUpperCase()
  ) as keyof typeof ENVS;

  return {
    region: isEMEA ? EMEA_REGION : (region?.toUpperCase() ?? DEFAULT_REGION),
    env: ENVS[envToUse] ?? ENVS.PRODUCTION,
    platform: platform as Platform,
  };
}
